import { Formik, Form, Field, ErrorMessage } from "formik";
import "./BillingEntityForm.css";

const BillingEntityForm = ({
  initialValues,
  validationSchema,
  fields,
  onSubmit,
  isSubmitting,
  submitLabel,
  cancelLabel = "Cancel",
  onCancel,
}) => (
  <Formik
    enableReinitialize
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={async (values) => {
      await onSubmit(values);
    }}
  >
    {() => (
      <Form className="billing-entity-form">
        <div className="billing-entity-form__grid">
          {fields.map((field) => {
            const fieldOptions = field.options || [];
            const fieldClassName = `billing-entity-form__field billing-entity-form__field--${
              field.width || "half"
            }`;

            return (
              <div className={fieldClassName} key={field.name}>
                <label className="billing-entity-form__label" htmlFor={field.name}>
                  {field.label}
                </label>

                {field.type === "textarea" ? (
                  <Field
                    as="textarea"
                    id={field.name}
                    name={field.name}
                    placeholder={field.placeholder}
                    className="billing-entity-form__input billing-entity-form__textarea"
                    rows={field.rows || 4}
                  />
                ) : field.type === "select" ? (
                  <Field
                    as="select"
                    id={field.name}
                    name={field.name}
                    className="billing-entity-form__input"
                  >
                    <option value="">{field.placeholder || `Select ${field.label}`}</option>
                    {fieldOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Field>
                ) : (
                  <Field
                    id={field.name}
                    name={field.name}
                    type={field.type || "text"}
                    placeholder={field.placeholder}
                    className="billing-entity-form__input"
                    min={field.min}
                    max={field.max}
                    step={field.step}
                  />
                )}

                {field.hint ? (
                  <p className="billing-entity-form__hint">{field.hint}</p>
                ) : null}

                <ErrorMessage
                  name={field.name}
                  component="div"
                  className="billing-entity-form__error"
                />
              </div>
            );
          })}
        </div>

        <div className="billing-entity-form__actions">
          <button
            type="button"
            className="billing-entity-form__button billing-entity-form__button--secondary"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="submit"
            className="billing-entity-form__button billing-entity-form__button--primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : submitLabel}
          </button>
        </div>
      </Form>
    )}
  </Formik>
);

export default BillingEntityForm;
